/* Store */
import { useToggleStore } from '~/store/toggle/toggle'
import { useCityStore } from '~/store/city/city'
import { useAnalyticsStore } from '~/store/analytics/analytics'

/* Vendor */
import vendorCarrotQuest from '@/services/metrics/vendor/carrot-quest'

/* Utils */
import { checkDevAndBranchOfEnv } from '@/utils/checkEnvironment'

/* Types */
import { CqType } from '@/types/metrics'

const setCssProperties = (CqType: CqType) => {
  const style = document.createElement('style')

  style.innerHTML = `
      .carrotquest-css-reset {
        display: ${CqType};
      }
    `

  document.head.appendChild(style)
}

export const useAppendCarrotQuest = async () => {
  const config = useRuntimeConfig()
  const MODE = config.public.MODE

  // Объявляем pinia store
  const toggleStore = useToggleStore()
  const cityStore = useCityStore()
  const analyticsStore = useAnalyticsStore()

  const { isDesktop } = useDevice()

  const { $sentryCaptureException } = useNuxtApp()

  const { carrotquest_enabled, carrotquest_site_chat_enabled } =
    toggleStore.featureToggle

  const cityName = cityStore.cityInfo.padeg?.imen

  const { carrotquest_id } = analyticsStore.analytics

  const cqCity = localStorage.getItem('cq_city')

  // Отключаем пиксель для dev режима
  if (checkDevAndBranchOfEnv('CarrotQuest', MODE)) return

  if (!carrotquest_enabled) return

  if (!carrotquest_site_chat_enabled || !isDesktop)
    setCssProperties(CqType.hide)

  try {
    const carrotquest = await vendorCarrotQuest(carrotquest_id)

    if (cityName && cqCity !== cityName) {
      localStorage.setItem('cq_city', cityName)
    }

    carrotquest.addCallback('messenger_opened', () => {
      if (!isDesktop) setCssProperties(CqType.show)
    })

    carrotquest.addCallback('messenger_closed', () => {
      if (!isDesktop) setCssProperties(CqType.hide)
    })
  } catch (error) {
    // @ts-ignore
    $sentryCaptureException(error)
  }
}
